import { useEffect, useState } from "react";
import { MapInterface, WidgetInterface } from "../../types";

interface Props {
    editable: boolean
    color: string
    colorSecondary : string
    widget  : WidgetInterface
    onUpdate: (id: string, updates: Partial<WidgetInterface>) => void;
}

function defaultMapInterface() : MapInterface {
  return {positionX: 0, positionY: 0}
}

export function MapWidget(props : Props) {
  const [blinker, setBlinker] = useState(true);
  const mapi : MapInterface = props.widget.data ? props.widget.data : defaultMapInterface();

  const handleClick = (relX : number, relY : number) => {
    props.onUpdate(props.widget.id, {
      data: {positionX: relX * 343.958, positionY: relY * 185.208}
    });
  }

  useEffect(() => {
        const b = setInterval(() => {setBlinker(!blinker)},500)
        return () => {
          clearInterval(b)
        }
  },[blinker]);

  return (
  <div onClick={(e : React.MouseEvent<HTMLDivElement>) => {props.editable ? handleClick(e.nativeEvent.offsetX / e.currentTarget.clientWidth,e.nativeEvent.offsetY / e.currentTarget.clientHeight) : ""}}>
<svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 343.958 185.208"
    {...props}
  >
    <path
      d="M179.638 50.649h28.251v5.622h-28.251zM179.638 41.042h28.251v5.622h-28.251zM226.916 50.649h28.251v5.622h-28.251zM226.916 41.042h28.251v5.622h-28.251z"
      style={{
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
    />
    <path
      d="M43.828-220.211h11.669v4.339H43.828z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(90)"
    />
    <path
      d="M163.777-1.533h66.985v23.501h-66.985z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(25.827)"
    />
    <path
      d="M-7.436-144.831H9.24v12.499H-7.436z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(114.655)"
    />
    <path
      d="M-31.805-146.685h8.486v4.322h-8.486z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(114.54)"
    />
    <path
      d="M34.225-163.953h22.82v20.083h-22.82zM35.334-122.558h24.248v23.194H35.334zM22.278-105.737h3.74v9.962h-3.74zM-9.28-78.069h33.456v20.335H-9.28z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(114.655)"
    />
    <path
      d="M174.646 7.305h99.523v27.746h-99.523z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
    />
    <path
      d="M226.916 33.893h32.958v5.622h-32.958zM174.39 33.875h35.739v5.622H174.39zM210.869 33.875h15.413v5.622h-15.413z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
    />
    <path
      d="m305.485-.297-1.712 129.014M284.301 144.204l5.144-11.8-3.48-1.513.454-11.498-9.531-10.44-22.845 11.953L140.73 66.29"
      style={{
        display: "inline",
        fill: "none",
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      d="m247.651 110.05-37.216-17.473 2.307-4.728M204.194 87.698l1.362-4.236-61.953-29.426-1.21 2.875M143.15 39.513l3.554-7.565-17.02-22.315 44.63-1.89"
      style={{
        display: "inline",
        fill: "none",
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      d="m134.904 16.517-6.203 4.69-6.959-11.422-63.844 4.992"
      style={{
        display: "inline",
        fill: "none",
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      d="M155.688.153h7.983v7.94h-7.983zM155.554 15.97h7.983v7.94h-7.983z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(25.158)"
    />
    <path
      d="m38.458 52.296 3.555-6.58 24.358 12.027"
      style={{
        display: "inline",
        fill: "none",
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      d="M22.749-127.023h3.179v13.868h-3.179zM13.495-146.67h12.5v15.711h-12.5z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(114.655)"
    />
    <path
      d="M262.015 35.142h12.138v9.48h-12.138z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
    />
    <circle
      cx={280.821}
      cy={38.605}
      r={6.16}
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      d="M261.362 91.407h28.037v2.413h-28.037z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
    />
    <path
      d="M267.281 52.22h20.197v27.006H274.24l-.302-11.498-6.884-.151z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        stroke: props.color,
        strokeWidth: 0.264224,
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      d="M12.599-319.288h44.77v13.539h-44.77z"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="rotate(114.655)"
    />
    <path
      d="M108.54 49.661 98.484 70.094"
      style={{
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        stroke: props.color,
        strokeWidth: 0.264224,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 119.41 69.895)"
    >
      <tspan x={-23} y={519.953}>
        {"WC"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 162.596 59.355)"
    >
      <tspan x={-23} y={519.953}>
        {"AISTIKATTILA"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 192.818 8.074)"
    >
      <tspan x={-23} y={519.953}>
        {"1A"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 192.897 17.674)"
    >
      <tspan x={-23} y={519.953}>
        {"1B"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 240.177 8.088)"
    >
      <tspan x={-23} y={519.953}>
        {"2B"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.colorSecondary,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 240.257 17.695)"
    >
      <tspan x={-23} y={519.953}>
        {"2A"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 180.402 .904)"
    >
      <tspan x={-23} y={519.953}>
        {"WEIGH & DINE"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 240.283 .92)"
    >
      <tspan x={-23} y={519.953}>
        {"VEGE"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 214.803 .902)"
    >
      <tspan x={-23} y={519.953}>
        {"GRILL"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 122.54 23.288)"
    >
      <tspan x={-23} y={519.953}>
        {"CAF\xC8"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      style={{
        fontSize: 56,
        fontFamily: "&quot",
        
        whiteSpace: "pre",
        
        display: "inline",
        fill: props.color,
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 6.80315,
        strokeDasharray: "none",
      }}
      transform="matrix(.07158 0 0 .07158 266.346 126.38)"
    >
      <tspan x={-23} y={519.953}>
        {"INFO"}
      </tspan>
    </text>
        <g transform={"translate("+(-366.062+mapi.positionX)+" "+(-188.382+mapi.positionY)+")"}>
      <circle
        cx={366.062}
        cy={188.762}
        r={2.78}
        style={{
          fill: blinker ? "#c00" : props.color,
          fillOpacity: 1,
          strokeWidth: 0.973446,
          strokeLinecap: "round",
          strokeLinejoin: "bevel",
        }}
      />
      <text
        xmlSpace="preserve"
        style={{
          fontSize: "21.3333px",
          fontFamily: "&quot",
          
          textAlign: "center",
          whiteSpace: "pre",
          
          display: "inline",
          fill: props.color,
          fillOpacity: 1,
          strokeWidth: 7.1811,
          strokeLinecap: "round",
          strokeLinejoin: "bevel",
        }}
        transform="matrix(.26458 0 0 .26458 90.936 90.273)"
      >
        <tspan x={988.932} y={316.411}>
          <tspan
            style={{
              fontWeight: 700,
              fontFamily: "&quot",
              
            }}
          >
            {"Olet t\xE4ss\xE4"}
          </tspan>
          <tspan
            style={{
              fontFamily: "&quot",
              
            }}
          />
        </tspan>
        <tspan x={999.116} y={343.077}>
          <tspan
            style={{
              fontSize: "14.6667px",
            }}
          >
            {"You are here"}
          </tspan>
        </tspan>
      </text>
    </g>
  </svg>
  </div>
);
}